export interface AdminUser {
  id: string;
  name: string;
  email: string;
  role: "admin" | "business" | "user";
  businessName?: string;
  avatar: string;
  joinDate: string;
  lastLogin: string;
  isActive: boolean;
}

export interface SupportTicket {
  id: string;
  ticketNo: string;
  userName: string;
  userEmail: string;
  subject: string;
  category: "technical" | "billing" | "content" | "general";
  priority: "low" | "medium" | "high";
  status: "open" | "in_progress" | "resolved" | "closed";
  createdAt: string;
  message: string;
}

export interface AdSlot {
  id: string;
  title: string;
  placement: string;
  advertiser: string;
  startDate: string;
  endDate: string;
  impressions: number;
  clicks: number;
  budget: number;
  status: "active" | "paused" | "ended";
  image: string;
}

export interface DashboardStat {
  label: string;
  value: string;
  change: string;
  trend: "up" | "down" | "neutral";
  icon: string;
  color: string;
}

export const dashboardStats: DashboardStat[] = [
  { label: "Toplam Mekan", value: "36", change: "+4 bu ay", trend: "up", icon: "ri-store-2-line", color: "bg-emerald-50 text-emerald-700" },
  { label: "Aktif Kampanya", value: "4", change: "+1 yeni", trend: "up", icon: "ri-coupon-line", color: "bg-amber-50 text-amber-700" },
  { label: "Aylık Ziyaretçi", value: "12.840", change: "+18%", trend: "up", icon: "ri-user-line", color: "bg-sky-50 text-sky-700" },
  { label: "Sponsorlu Mekan", value: "7", change: "Sabit", trend: "neutral", icon: "ri-advertisement-line", color: "bg-violet-50 text-violet-700" },
  { label: "Bekleyen Destek", value: "3", change: "-2 çözüldü", trend: "down", icon: "ri-customer-service-2-line", color: "bg-red-50 text-red-700" },
  { label: "Aktif İşletme", value: "14", change: "+2 bu ay", trend: "up", icon: "ri-building-line", color: "bg-stone-100 text-stone-700" },
];

export const weeklyVisitors = [
  { day: "Pzt", value: 1240, pct: 62 },
  { day: "Sal", value: 980, pct: 49 },
  { day: "Çrş", value: 1560, pct: 78 },
  { day: "Prş", value: 1340, pct: 67 },
  { day: "Cum", value: 1820, pct: 91 },
  { day: "Cmt", value: 2000, pct: 100 },
  { day: "Paz", value: 1750, pct: 87 },
];

export const categoryDistribution = [
  { label: "Tarihi", count: 7, pct: 19, color: "bg-amber-500" },
  { label: "Lezzet", count: 7, pct: 19, color: "bg-red-500" },
  { label: "Eğlence", count: 5, pct: 14, color: "bg-sky-500" },
  { label: "Konaklama", count: 6, pct: 17, color: "bg-violet-500" },
  { label: "Doğa", count: 5, pct: 14, color: "bg-emerald-500" },
  { label: "Gezilecek", count: 6, pct: 17, color: "bg-stone-500" },
];

export const adminUsers: AdminUser[] = [
  { id: "u1", name: "Ahmet Yılmaz", email: "ahmet@bursaguide360.com", role: "admin", avatar: "AY", joinDate: "01.01.2025", lastLogin: "Bugün, 09:14", isActive: true },
  { id: "u2", name: "Mehmet Şahin", email: "info@iskender.com.tr", role: "business", businessName: "Kebapçı İskender", avatar: "MŞ", joinDate: "15.02.2025", lastLogin: "Dün, 14:30", isActive: true },
  { id: "u3", name: "Ayşe Kaya", email: "rezervasyon@gumuspala.com.tr", role: "business", businessName: "Gümüşpala Termal", avatar: "AK", joinDate: "20.02.2025", lastLogin: "2 gün önce", isActive: true },
  { id: "u4", name: "Fatih Demir", email: "info@extrempark.com.tr", role: "business", businessName: "Extrempark Bursa", avatar: "FD", joinDate: "05.03.2025", lastLogin: "Bugün, 11:02", isActive: true },
  { id: "u5", name: "Zeynep Arslan", email: "zeynep.arslan@gmail.com", role: "user", avatar: "ZA", joinDate: "10.03.2025", lastLogin: "3 gün önce", isActive: true },
  { id: "u6", name: "Can Yıldız", email: "can.yildiz@gmail.com", role: "user", avatar: "CY", joinDate: "12.03.2025", lastLogin: "1 hafta önce", isActive: false },
  { id: "u7", name: "Selin Bozkurt", email: "info@aquabursa.com.tr", role: "business", businessName: "Aqua Bursa Su Parkı", avatar: "SB", joinDate: "18.03.2025", lastLogin: "Dün, 09:45", isActive: true },
  { id: "u8", name: "Murat Çelik", email: "murat.celik@hotmail.com", role: "user", avatar: "MÇ", joinDate: "25.03.2025", lastLogin: "Bugün, 08:20", isActive: true },
];

export const supportTickets: SupportTicket[] = [
  {
    id: "t1", ticketNo: "#BG-1042",
    userName: "Mehmet Şahin", userEmail: "info@iskender.com.tr",
    subject: "Fotoğraf yüklemede sorun yaşıyorum",
    category: "technical", priority: "high", status: "open",
    createdAt: "29.03.2026, 08:45",
    message: "Galeri bölümüne fotoğraf yüklemeye çalışıyorum ama hata alıyorum.",
  },
  {
    id: "t2", ticketNo: "#BG-1041",
    userName: "Ayşe Kaya", userEmail: "rezervasyon@gumuspala.com.tr",
    subject: "Kampanya kupon kodu güncellenmesi",
    category: "content", priority: "medium", status: "in_progress",
    createdAt: "28.03.2026, 15:20",
    message: "Erken rezervasyon kampanyamızın kupon kodunu güncellemek istiyoruz.",
  },
  {
    id: "t3", ticketNo: "#BG-1040",
    userName: "Fatih Demir", userEmail: "info@extrempark.com.tr",
    subject: "Sponsorlu içerik faturası hakkında",
    category: "billing", priority: "medium", status: "in_progress",
    createdAt: "27.03.2026, 11:10",
    message: "Mart ayı sponsorlu içerik faturasını talep ediyoruz.",
  },
  {
    id: "t4", ticketNo: "#BG-1039",
    userName: "Selin Bozkurt", userEmail: "info@aquabursa.com.tr",
    subject: "Mekan açıklamamı güncellemek istiyorum",
    category: "content", priority: "low", status: "resolved",
    createdAt: "26.03.2026, 09:30",
    message: "Su parkı açıklamamızda bazı bilgilerin güncellenmesi gerekiyor.",
  },
  {
    id: "t5", ticketNo: "#BG-1038",
    userName: "Can Yıldız", userEmail: "can.yildiz@gmail.com",
    subject: "Rotalar sayfasındaki bilgi hatası",
    category: "general", priority: "low", status: "closed",
    createdAt: "25.03.2026, 16:00",
    message: "Aile Rotasındaki bir mekanın açılış saati yanlış yazılmış.",
  },
];

export const adSlots: AdSlot[] = [
  {
    id: "a1", title: "Extrempark Yaz Kampanyası",
    placement: "Ana Sayfa Hero", advertiser: "Extrempark Bursa",
    startDate: "01.04.2026", endDate: "30.06.2026",
    impressions: 48200, clicks: 1930, budget: 4500, status: "active",
    image: "https://public.readdy.ai/ai/img_res/ccb4d6d789eb9ed685d9dff8647b242b.jpg",
  },
  {
    id: "a2", title: "Gümüşpala Erken Rezervasyon",
    placement: "Kategori Sayfası Banner", advertiser: "Gümüşpala Termal",
    startDate: "15.03.2026", endDate: "15.05.2026",
    impressions: 31500, clicks: 840, budget: 3200, status: "active",
    image: "https://readdy.ai/api/search-image?query=thermal%20hotel%20early%20booking%20promotion%20luxury%20wellness%20Bursa%20discount%20offer%20elegant%20spa%20pool%20Turkey&width=400&height=220&seq=ad02&orientation=landscape",
  },
  {
    id: "a3", title: "Aqua Bursa Sezon Açılışı",
    placement: "Eğlence Kategorisi Üstü", advertiser: "Aqua Bursa Su Parkı",
    startDate: "01.05.2026", endDate: "31.08.2026",
    impressions: 0, clicks: 0, budget: 2800, status: "paused",
    image: "https://readdy.ai/api/search-image?query=water%20park%20opening%20season%20promotion%20summer%20Turkey%20slides%20pool%20family%20fun%20discount%20offer&width=400&height=220&seq=ad03&orientation=landscape",
  },
  {
    id: "a4", title: "Botanik Park Aile Paketi",
    placement: "Doğa Kategorisi Sidebar", advertiser: "Bursa Botanik Parkı",
    startDate: "01.02.2026", endDate: "28.02.2026",
    impressions: 22100, clicks: 610, budget: 1200, status: "ended",
    image: "https://readdy.ai/api/search-image?query=botanical%20garden%20family%20park%20promotion%20children%20outdoor%20nature%20green%20Bursa%20Turkey%20discount%20offer&width=400&height=220&seq=ad04&orientation=landscape",
  },
];

export const recentActivity = [
  { id: 1, type: "venue_added", text: "Yeni mekan eklendi: Gölyazı Köyü", time: "2 saat önce", icon: "ri-store-add-line", color: "text-emerald-600" },
  { id: 2, type: "ticket_open", text: "Yeni destek talebi: #BG-1042", time: "3 saat önce", icon: "ri-customer-service-2-line", color: "text-red-500" },
  { id: 3, type: "campaign_updated", text: "Kampanya güncellendi: Extrempark %30", time: "5 saat önce", icon: "ri-coupon-line", color: "text-amber-600" },
  { id: 4, type: "user_joined", text: "Yeni işletme kaydı: Selin Bozkurt", time: "Dün, 14:20", icon: "ri-user-add-line", color: "text-sky-600" },
  { id: 5, type: "venue_updated", text: "Mekan güncellendi: Gümüşpala Termal", time: "Dün, 11:05", icon: "ri-edit-line", color: "text-stone-500" },
  { id: 6, type: "ad_started", text: "Yeni reklam başladı: Gümüşpala Erken Rezervasyon", time: "2 gün önce", icon: "ri-advertisement-line", color: "text-violet-600" },
];
